/**
 * Editor de **configuración** del cálculo.
 *
 * Tras la feature #75 el panel conserva ÚNICAMENTE el grosor de corte (kerf, en cm),
 * que afecta el corte real. El antiguo selector de "nivel de optimización" (slider
 * 1..5) y su caja informativa se retiraron: el algoritmo entrega siempre el mejor
 * resultado con esfuerzo interno y adaptativo (ver `optimizer.ts`). Presentacional:
 * recibe la config y emite cambios al orquestador; no toca la API ni mantiene estado
 * propio.
 */
import { Input } from "@/components/ui";

import type { CutConfig } from "../types";

interface ConfigEditorProps {
  config: CutConfig;
  onUpdate: (patch: Partial<CutConfig>) => void;
}

export function ConfigEditor({ config, onUpdate }: ConfigEditorProps) {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-1">
        <label htmlFor="cl-kerf" className="text-sm font-medium text-slate-700">
          Grosor de corte (kerf)
          <span className="font-normal text-slate-400">
            {" "}
            — material que consume la sierra
          </span>
        </label>
        <div className="flex items-center gap-3">
          <Input
            id="cl-kerf"
            type="number"
            min={0}
            max={2}
            step={0.05}
            className="w-28"
            value={config.cutThickness}
            onChange={(e) =>
              onUpdate({ cutThickness: parseFloat(e.target.value) || 0 })
            }
          />
          <span className="text-sm text-slate-500">
            cm{" "}
            <span className="text-slate-400">
              ({(config.cutThickness * 10).toFixed(1)} mm)
            </span>
          </span>
        </div>
      </div>
    </div>
  );
}
